class LowestPriceGuaranteePopup extends Component {
    constructor(el) {
        super(el);
        //this.form = this.$find('form');
        this.lowestPriceGuaranteeOpener = document.querySelector('[data-lowest-price-guarantee-opener]');

        this.openLowestPriceModalIfNeeded();
        this.addEventListeners();
    }


    openLowestPriceGuaranteePopup() {
        EventBus.getInstance().dispatchEvent('showBasePopup', 'lowest-price-guarantee-popup');
    }

    openLowestPriceModalIfNeeded() {
        if (document.querySelector('[data-open-lowest-price-guarantee-popup]') !== null) {
            this.openLowestPriceGuaranteePopup();
        }
    }

    addEventListeners() {
        this.lowestPriceGuaranteeOpener && this.lowestPriceGuaranteeOpener.addEventListener('click', () => this.openLowestPriceGuaranteePopup());
    }

    //Řešení ajaxem odloženo

    // constructor(el) {
    //     super(el);
    //     this.form = this.$find('form');
    //     this.alert = this.$find('[data-lowest-price-guarantee-alert]');
    //     this.addEventListener();
    // }

    // formSubmitted(data) {
    //     if (data.result === false) {
    //         if (data.form) {
    //             const formHtml = document.createElement('temporary');
    //             formHtml.innerHTML = data.form;
    //             this.form.innerHTML = formHtml.querySelector('form').innerHTML;
    //         }
    //         if (data.alert) {
    //             this.alert.querySelector('[data-text]').innerHTML = data.alert;
    //             this.alert.classList.remove('u-hidden');
    //         } else {
    //             this.alert.classList.add('u-hidden');
    //         }
    //     } else {
    //         //todo zobrazit hlášku o úspěchu
    //     }
    // }
    //
    // onFormSubmit(e) {
    //     e.preventDefault();
    //
    //     const formData = new FormData(this.form);
    //
    //     fetch(this.form.getAttribute('action'), {
    //         method: 'POST',
    //         body: formData,
    //     })
    //         .then(response => response.json())
    //         .then(data => this.formSubmitted(data))
    //         .catch((error) => {
    //             //todo udělat jako normální hlášku uživateli - lokalizovaná
    //             console.error('Error:', error);
    //         });
    // }
    //
    // addEventListener() {
    //     this.form.addEventListener('submit', e => this.onFormSubmit(e));
    // }
}
